module.exports = __webpack_public_path__ + "img/1.d87aa000.jpg";